module.exports = __webpack_public_path__ + "img/neoserf.48d14c8c.svg";